import { C } from '../theme';

export function LogoMark({ size = 40 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 48 48"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="Floxir"
    >
      <rect x="2" y="2" width="44" height="44" rx="12" fill={C.orange} />
      <g transform="translate(7,0) skewX(-14)">
        <path
          d="M13 13 L35 35"
          stroke={C.logoX}
          strokeWidth="7"
          strokeLinecap="round"
          fill="none"
        />
        <path
          d="M35 13 L13 35"
          stroke={C.logoX}
          strokeWidth="7"
          strokeLinecap="round"
          fill="none"
        />
        <rect x="15" y="12" width="6" height="24" rx="2" fill="#fff" />
        <rect x="15" y="12" width="15" height="6" rx="2" fill="#fff" />
        <rect x="15" y="21" width="11" height="6" rx="2" fill="#fff" />
      </g>
    </svg>
  );
}

export default function Logo({ size = 40, wordmarkSize = 27, onDark = false }) {
  const wordmarkColor = onDark ? C.bg : C.orange;
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: size >= 40 ? 11 : 9 }}>
      <LogoMark size={size} />
      <span
        style={{
          fontSize: wordmarkSize,
          fontWeight: 500,
          fontStyle: 'italic',
          color: wordmarkColor,
          letterSpacing: '-0.5px',
          display: 'inline-block',
          transform: 'skewX(-8deg)',
        }}
      >
        Floxir
      </span>
    </div>
  );
}
